import { Link } from '@inertiajs/react'

interface Props {
  variant?: 'lendsolo' | 'debtlens'
}

export default function MarketingFooter({ variant = 'lendsolo' }: Props) {
  const isDebtLens = variant === 'debtlens'

  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div
              className="w-6 h-6 rounded flex items-center justify-center"
              style={{ backgroundColor: '#0F1419' }}
            >
              <span className="text-emerald-400 font-bold text-xs">LS</span>
            </div>
            <span className="text-sm text-gray-500">
              {isDebtLens
                ? 'DebtLens by LendSolo'
                : 'LendSolo — Loan management for private lenders'}
            </span>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-500">
            <Link href="/blog" className="hover:text-gray-700">Blog</Link>
            <Link href="/tools/loan-amortization-calculator" className="hover:text-gray-700">Amortization</Link>
            <Link href="/tools/roi-calculator" className="hover:text-gray-700">ROI Calculator</Link>
            <Link href="/tools/loan-comparison" className="hover:text-gray-700">Loan Comparison</Link>
            <Link href="/tools/interest-only-calculator" className="hover:text-gray-700">Interest-Only</Link>
            <Link href="/tools/true-cost-calculator" className="hover:text-gray-700">True Cost</Link>
            <Link href="/privacy" className="hover:text-gray-700">Privacy</Link>
            <Link href="/terms" className="hover:text-gray-700">Terms</Link>
            <Link href="/cookies" className="hover:text-gray-700">Cookie Policy</Link>
            <a href="mailto:support@lendsolo.com" className="hover:text-gray-700">support@lendsolo.com</a>
          </nav>
        </div>
      </div>
    </footer>
  )
}
